<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <div :class="dropdownStyles">
    <div
      :class="containerStyles"
      @click="toggleDropdown"
    >
      <label 
        :class="[
          'font-bold text-xs sm:text-sm mr-[10px] hover:text-typography transition-all ease-in-out duration-200',
          theme === 'dark' ? 'text-white-40' : 'text-aubergine-40',
        ]"
        >{{ label }}</label
      >
      <p
        :class="[
          'font-bold text-xs sm:text-sm text-aubergine mr-[10px]',
          theme === 'dark' ? 'text-white' : 'text-aubergine',
        ]"
      >
        {{ selectedOptionLabel }}
      </p>
      <ArrowButton :isOpen="isOpen" />
    </div>
    <Transition
      enter-active-class="transition-all duration-500 in-expo"
      leave-active-class="transition-all duration-300 out-expo"
      enter-from-class="opacity-0 -translate-y-1/2"
      leave-to-class="opacity-0 -translate-y-1/2"
    >
      <ul v-if="isOpen" 
        :class="ulStyles"
        role="listbox"
        >
        <li
          v-for="(option, index) in options"
          :key="index"
          role="option"
          tabindex="0"
          :aria-selected="selectedOptionLabel === Object.keys(option)[0] ? 'true' : 'false'"
          @click="selectOption(option)"
          @keyup.enter.prevent="selectOption(option)"
          :class="[
            'font-bold text-aubergine px-[13px] py-[18px] inline-block hover:text-orange',
            theme === 'dark' ? 'text-white' : 'text-aubergine',
            isNewsFilter ? '' : 'last:border-none',
            selectedOptionLabel === Object.keys(option)[0] ? 'text-orange' : '',
          ]"
        >
          {{ Object.keys(option)[0] }}
        </li>
      </ul>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import { ref, toRefs, computed } from "vue";
import ArrowButton from "@atoms/Dropdown/ArrowButton.vue";

export type Option = Record<string, string>;
interface DropdownProps {
  options: Option[];
  label: string;
  selectedOption: Option | null;
  theme: "dark" | "light";
  classes: string;
  isNewsFilter?: boolean;
  isCategoryFilter?: boolean;
  removePadding?: boolean;
}

type Emits = {
  (e: "selectOption", option: Option): void;
};
const emit = defineEmits<Emits>();

const props = withDefaults(defineProps<DropdownProps>(), {
  theme: "light",
});
const {
  options,
  label,
  selectedOption,
  theme,
  classes,
  isNewsFilter,
  isCategoryFilter,
  removePadding,
} = toRefs(props);

const isOpen = ref(false);

function toggleDropdown() {
  isOpen.value = !isOpen.value;
}

function selectOption(option: Option) {
  emit("selectOption", option);
  isOpen.value = false;
}

const selectedOptionLabel = computed(() => {
  if (!selectedOption.value) return;
  return Object.keys(selectedOption.value)[0];
});

const dropdownStyles = computed(() => {
  const minWidth = removePadding.value == true ? "" : "min-w-[240px]";
  return `inline-flex flex-col relative bg-primary ${minWidth} ${classes.value}`;
});
const ulStyles = computed(() => {
  console.log(removePadding, "removePadding")
  const borders = isNewsFilter
    ? "pl-6 pb-12 lg:pl-10 lg:pb-12"
    : "border-2 border-aubergine-40";
  return `bg-primary min-w-[240px] inline-flex flex-col absolute right-0 top-16 z-10 [&>*]:border-b-2 [&>*]:border-aubergine-40 ${borders}`;
});

const containerStyles = computed(() => {
  return `relative ${removePadding.value == true ? "h-full flex relative items-center justify-end z-0 bg-primary " : "h-full flex relative items-center justify-end z-0 bg-primary pt-8 2xl:pt-0 min-w-[240px]"}`;
});
</script>
